// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 434 ? "38bf0c65" : chunkId) + "." + {"434":"73a7fa5a35f754f9","831":"100e97911d746495"}[chunkId] + ".js";
};